import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "d2-learning",
  "use": "d2-learning-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 26\" id=\"d2-learning\">\n  <defs>\n    <style>\n      #d2-learning .cls-1 {\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path id=\"d2-learning_形状_556\" data-name=\"形状 556\" class=\"cls-1\" d=\"M22,6c0,2.91,0,15,0,15H19V11l-1,1v9H14V15l-1,1v5H9V17L8,18v3H4V18S16.964,18,22,6ZM3,17v5H23V5H21C20.761,5,17.442,17,3,17Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol